import { useFlag } from '@reflag/react-sdk';

import { useCurrentOrganization } from '../../state';

/**
 * Check if AI is enabled at the organization level for the current organization context.
 */
export function useHasAIEnabled(): boolean {
    const organization = useCurrentOrganization();
    return Boolean(organization.ai);
}

/**
 * Check if the GitBook Agent is enabled for the current organization.
 * Requires both the feature flag and the organization AI toggle.
 */
export function useAgentEnabled(): boolean {
    const { isEnabled: docsAgentsFeature } = useFlag('DOCS_AGENTS');
    const hasAIEnabled = useHasAIEnabled();

    return docsAgentsFeature && hasAIEnabled;
}
